(function() {
  var seoTitles = {
    'the-jeffrey-cooler': 'Tailgate Pad Cooler for Trucks — The Jeffrey',
    'anchor-lock': 'Tailgate Pad Anchor Lock for Trucks',
    '4-pack-bike-straps': 'Tailgate Pad Bike Straps — 4-Pack',
    'cargo-net': 'Tailgate Pad Cargo Net for Trucks',
    'skid-plate': 'Tailgate Pad Skid Plate for Trucks',
    'the-lounger-chair': 'Tailgate Pad Lounger Chair',
    'taxi-way-tote-bag': 'Tailgate Pad Tote Bag — Taxiway',
    'jeffrey-cooler-two-lounger-chairs': 'Tailgate Pad Cooler and Lounger Chair Bundle'
  };

  var path = window.location.pathname;
  var match = path.match(/\/products\/([^/?#]+)/);
  if (!match) return;

  var handle = match[1];
  var seoTitle = seoTitles[handle];
  if (!seoTitle) return;

  document.addEventListener('DOMContentLoaded', function() {
    var h1 = document.createElement('h1');
    h1.className = 'cache-seo-h1';
    h1.textContent = seoTitle;
    document.body.insertBefore(h1, document.body.firstChild);
  });
})();
